import createIcon from '../../createIcon';

/**
 * @component @name Stroller
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMjEuNUMxNi4xMDQ2IDIxLjUgMTcgMjAuNjA0NiAxNyAxOS41QzE3IDE4LjM5NTQgMTYuMTA0NiAxNy41IDE1IDE3LjVDMTMuODk1NCAxNy41IDEzIDE4LjM5NTQgMTMgMTkuNUMxMyAyMC42MDQ2IDEzLjg5NTQgMjEuNSAxNSAyMS41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTUgMjEuNUM2LjEwNDU3IDIxLjUgNyAyMC42MDQ2IDcgMTkuNUM3IDE4LjM5NTQgNi4xMDQ1NyAxNy41IDUgMTcuNUMzLjg5NTQzIDE3LjUgMyAxOC4zOTU0IDMgMTkuNUMzIDIwLjYwNDYgMy44OTU0MyAyMS41IDUgMjEuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMSA2LjVWNS45OEMyMSA0LjA2IDE5LjUyIDIuNSAxNy42NSAyLjVDMTUuOTkgMi41IDE1LjExIDMuNzcgMTQuNDcgNC41M0w1LjY3IDE0Ljg1QzUuMTIgMTUuNSA1LjU4IDE2LjUgNi40MyAxNi41SDE0QzE1LjEgMTYuNSAxNiAxNS42IDE2IDE0LjVWNS43N0MxNi41OCA1LjA5IDE2Ljk3IDQuNSAxNy42NSA0LjVDMTguNDIgNC41IDE5IDUuMTYgMTkgNS45OFY2LjVIMjFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMuMyAzLjZDMTIuMDMgMi45IDEwLjU2IDIuNSA5IDIuNUM3LjAzIDIuNSA1LjIxIDMuMTQgMy43MiA0LjIyTDguNjEgOS4xMUwxMy4zIDMuNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Stroller = createIcon('Stroller', [
  [
    'path',
    {
      d: 'M15 21.5C16.1046 21.5 17 20.6046 17 19.5C17 18.3954 16.1046 17.5 15 17.5C13.8954 17.5 13 18.3954 13 19.5C13 20.6046 13.8954 21.5 15 21.5Z',
      key: '1npsst',
    },
  ],
  [
    'path',
    {
      d: 'M5 21.5C6.10457 21.5 7 20.6046 7 19.5C7 18.3954 6.10457 17.5 5 17.5C3.89543 17.5 3 18.3954 3 19.5C3 20.6046 3.89543 21.5 5 21.5Z',
      key: 'na3jy7',
    },
  ],
  [
    'path',
    {
      d: 'M21 6.5V5.98C21 4.06 19.52 2.5 17.65 2.5C15.99 2.5 15.11 3.77 14.47 4.53L5.67 14.85C5.12 15.5 5.58 16.5 6.43 16.5H14C15.1 16.5 16 15.6 16 14.5V5.77C16.58 5.09 16.97 4.5 17.65 4.5C18.42 4.5 19 5.16 19 5.98V6.5H21Z',
      key: '1kcw7r',
    },
  ],
  [
    'path',
    {
      d: 'M13.3 3.6C12.03 2.9 10.56 2.5 9 2.5C7.03 2.5 5.21 3.14 3.72 4.22L8.61 9.11L13.3 3.6Z',
      key: '1hvub8',
    },
  ],
]);

export default Stroller;
